// extracted by mini-css-extract-plugin
export var container = "_a1-0";